/**
 * API Configuration
 * 
 * Controls whether to use backend API or local/mock data.
 * Set REACT_APP_USE_BACKEND=false to disable; otherwise backend is used.
 */

// Use backend unless explicitly set to "false" (case-insensitive)
const useBackendEnv = process.env.REACT_APP_USE_BACKEND;
export const USE_BACKEND = useBackendEnv !== undefined && useBackendEnv !== ''
    ? useBackendEnv.toLowerCase() !== 'false'
    : true;

// API base URL
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';

// Log configuration on startup (only in development)
if (process.env.NODE_ENV === 'development') {
    console.log('API Configuration:', {
        USE_BACKEND,
        API_BASE_URL,
    });
}

